import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './layouts/App';



ReactDOM.render(<App />, document.getElementById('root'));
